<template>
  <div>
    <!-- <iframe
      v-if="isShow"
      :src="iframeSrc"
    /> -->
    <div v-if="isShow" class="no-permissions">
      <img src="@/assets/img/pic_kongde.png" alt="">
      <p>暂无权限</p>
    </div>
    <carriersSelectDialog ref="CarriersSelect" @select="handleSelect"></carriersSelectDialog>
  </div>
</template>

<script>
// import base from '@/api/base'
import carriersSelectDialog from '@/pages/orderManage/components/carriersSelectDialog.vue'
import env from '../../../../env/index'

export default {
  name: 'GoodsPlate',
  components:{
    carriersSelectDialog
  },
  data() {
    return {
      iframeSrc: '',
      isShow: false,
    }
  },
  created() {
    // this.getDictionary()
    // this.iframeSrc = `${env.WMS_IFRAME}warehouse?level=2&tag=oms&token=${this.$store.state.user.token}`
    const {creditCode,customerCode,tenantId,token}=this.$store.state.user
    if(!creditCode){
      if(!env.wmsTenantIds.includes(tenantId)){
        this.isShow=true
      }else{
        this.openWebPage(tenantId,customerCode,token)
      }
    }
  },
  mounted(){
    const {creditCode}=this.$store.state.user
    if(creditCode){
      this.$refs.CarriersSelect.init()
    }
  },
  methods: {
     handleSelect(select){
      if(!env.wmsTenantIds.includes(select.carrierTenantId)){
        this.isShow=true
      }else{
        const {token} = this.$store.state.user
        this.openWebPage(select.carrierTenantId,select.customerCode,token)
      }
    },
    openWebPage(tId,cId,token){
      window.location.replace(`${env.WMS_IFRAME}warehouse?level=2&tId=${tId}&cId=${cId}&token=${token}&tag=oms`)
    }
    // async getDictionary() {
    //   const res = await base.getDictionary({
    //     status: 1,
    //     type: 'goods_plate_white'
    //   })
    //   this.isDone = true
    //   const {customerCode,creditCode,customers} = this.$store.state.user
    //   if(creditCode){
    //   const customerCodes= customers.map(item=>item.customerCode)
    //   this.isShow=res.some(item=>customerCodes.includes(item.dictionaryCode))
    //   }else{
    //   const list = res.filter(item => item.dictionaryCode === customerCode)
    //   this.isShow = !!list.length
    //   }
    // }
  }
}
</script>

<style lang="less" scoped>
iframe {
  width: 100%;
  height: calc(100vh - 120px);
  border: none;
}
.no-permissions {
  text-align: center;
  img {
    width: 248px;
    height: 248px;
  }
}
</style>
